const speed = 50;

if(document.querySelector(".image-slider_container")){
  let target = document.querySelector(".image-slider_container");
  let original_html = target.innerHTML;

  let new_html = "<div class='slider_items'>" + original_html + "</div>";
  target.innerHTML = new_html;
  target.innerHTML += new_html;

  let tickerWidth = document.querySelector(".slider_items").offsetWidth;
  let initDuration = tickerWidth / speed;

  gsap.to(".slider_items", {
    duration: initDuration,
    xPercent: -100,
    ease: "none",
    repeat: -1
  });
}